import { DEMO_ADMIN_CUSTOMERS } from './fixtures/admin-customers.fixtures';

/**
 * S4-19 Helper (Findings D-07): einheitliches eager-loaded
 * `customer`-Sub-Object für Admin-Listen-Items. Im Dummy-Modus liefern
 * mehrere Facades dieselbe Struktur — diese Funktion ersetzt 2 Kopien
 * im `dummy-admin-documents.facade` und `dummy-admin-transactions.facade`.
 *
 * Fallback bei nicht-zuordenbarem Kunden: minimale Stub-Struktur statt
 * Crash. Der Fallback-Name `'—'` wird in der UI nur als letzte Stufe
 * sichtbar (z. B. ein Kunde, der gelöscht wurde, dessen historische
 * Doku/TX noch hängt). Anzeige-Texte sind absichtlich kein i18n-Key —
 * sie matchen kein fachliches Konzept und sollen nie produktiv sichtbar
 * werden.
 */
export interface CustomerStub {
  readonly id: number;
  readonly first_name: string;
  readonly last_name: string;
  readonly depot_number: string;
  /**
   * Sprint 8: Empfänger-Vorschau für den
   * `consulted → invoiced`-Confirm-Dialog. Adress-Felder sind im Dummy
   * Demo-Stub-Werte (keine echten Stammdaten) — ausreichend, um das
   * Pre-Invoice-Empfänger-Modal sinnvoll zu rendern.
   */
  readonly email?: string | null;
  readonly address_street?: string | null;
  readonly address_zip?: string | null;
  readonly address_city?: string | null;
  readonly address_country?: string | null;
}

export function resolveCustomerStub(customerId: number): CustomerStub {
  const found = DEMO_ADMIN_CUSTOMERS.find((c) => c.id === customerId);
  if (found) {
    return {
      id: found.id,
      first_name: found.first_name,
      last_name: found.last_name,
      depot_number: found.depot_number,
      email: found.email,
      address_street: 'Beispielstrasse 1',
      address_zip: '1010',
      address_city: 'Wien',
      address_country: 'AT',
    };
  }
  return {
    id: customerId,
    first_name: '—',
    last_name: '',
    depot_number: '—',
  };
}
